(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hemmie-bf-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  let interval;
  const initialize = () => {
    clearInterval(interval);
    const config = document.getElementById('hbf-campaign-config');
    if (!config) return;
    const enabled = config.dataset.enabled === 'true';
    document.body.classList.toggle('hbf-campaign-active', enabled);
    const clocks = [...document.querySelectorAll('[data-hbf-countdown]')];
    const isoDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/;
    const parseDate = value => isoDate.test(value || '') ? Date.parse(value) : NaN;
    const start = parseDate(config.dataset.start);
    const cyber = parseDate(config.dataset.cyber);
    const end = parseDate(config.dataset.end);
    const valid = enabled && Number.isFinite(start) && Number.isFinite(cyber) && Number.isFinite(end) && start < cyber && cyber < end;
    if (!valid) { clocks.forEach(clock => { clock.hidden = true; }); return; }
    const endFormatter = new Intl.DateTimeFormat(document.documentElement.lang || 'sv-SE', { timeZone: 'Europe/Stockholm', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    document.querySelectorAll('[data-hbf-end-display]').forEach(element => { element.textContent = endFormatter.format(new Date(end - 1000)); });
    const automatic = config.dataset.mode === 'automatic' || config.dataset.mode === 'black_month';
    let previousCampaign = '';
    const update = () => {
      const now = Date.now();
      const state = now < start && config.dataset.mode !== 'black_month' ? 'upcoming' : now < end ? 'active' : 'ended';
      const isCyber = config.dataset.mode === 'cyber_monday' || (automatic && now >= cyber);
      const name = isCyber ? config.dataset.cyberMonday : config.dataset.mode === 'black_month' ? config.dataset.blackMonth : config.dataset.blackFriday;
      if (name !== previousCampaign) {
        document.querySelectorAll('[data-hbf-label]').forEach(element => { element.textContent = name; });
        document.querySelectorAll('[data-hbf-heading]').forEach(element => {
          const words = name.split(' ');
          const line = document.createElement('em');
          line.textContent = words.slice(1).join(' ') + '.';
          element.replaceChildren(document.createTextNode(words[0]), line);
        });
        previousCampaign = name;
      }
      const target = state === 'upcoming' ? start : (config.dataset.mode !== 'black_month' && automatic && !isCyber && now < cyber ? cyber : end);
      const remaining = Math.max(0, Math.ceil((target - now) / 1000));
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor(remaining % 86400 / 3600);
      const minutes = Math.floor(remaining % 3600 / 60);
      const seconds = remaining % 60;
      const label = state === 'upcoming' ? config.dataset.startLabel : state === 'active' ? (target === cyber && config.dataset.mode !== 'black_month' ? config.dataset.bfEndLabel : config.dataset.endLabel) : config.dataset.expiredLabel;
      clocks.forEach(clock => {
        clock.hidden = false;
        clock.dataset.state = state;
        clock.querySelector('[data-hbf-clock-label]').textContent = label;
        [['days', days], ['hours', hours], ['minutes', minutes], ['seconds', seconds]].forEach(([unit, value]) => {
          clock.querySelector('[data-hbf-' + unit + ']').textContent = String(value).padStart(2, '0');
        });
        const description = state === 'ended' ? label : `${label} ${days} ${config.dataset.dayLabel}, ${hours} ${config.dataset.hourLabel}, ${minutes} ${config.dataset.minuteLabel}.`;
        clock.querySelector('[data-hbf-clock-description]').textContent = description;
      });
      if (state === 'ended') clearInterval(interval);
    };
    update();
    if (Date.now() < end && !document.hidden) interval = setInterval(update, 1000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('visibilitychange', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
